import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface EpcDashboard {
  kpis: {
    activeProjects: number;
    milestonesTotal: number;
    milestonesCompleted: number;
    overallProgressPct: number;
    overdueMilestones: number;
    handoversPending: number;
    invoicedValue: number;
    collectedValue: number;
    outstandingValue: number;
    retentionHeld: number;
  };
  costVsBudget: {
    boqApproved: number;
    poOrdered: number;
    workOrders: number;
    invoiced: number;
    collected: number;
    vendorApproved: number;
    vendorPaid: number;
  };
  breakdowns: {
    milestonesByStatus: Record<string, number>;
    purchaseOrdersByStatus: Record<string, number>;
    workOrdersByStatus: Record<string, number>;
    invoicesByStatus: Record<string, number>;
    handoversByStatus: Record<string, number>;
  };
}

export const epcDashboardApi = {
  overview: async (projectId?: number) =>
    (await apiClient.get<ApiSuccess<EpcDashboard>>('/epc-dashboard/overview', { params: projectId ? { projectId } : {} })).data.data,
};
